<template>
  <div>
    <v-card height="64px" width="100%"
      class="mx-4 my-0 px-4  background  elevation-0 d-flex flex-row justify-space-between align-center"
      style="position:fixed; z-index:200; top:0; width: 98%; padding-top: 16px;">
      <!-- <v-card-title>
          Create Role <v-span><v-icon class="ml-2 ">mdi-chevron-down</v-icon></v-span>
        </v-card-title> -->
      <div class="d-flex w-100 flex-row justify-space-between">
        <div class="ma-0 pa-0">
          <span class="cursor text-body-2" @click="$router.push('/roles')">Role</span>
          <v-icon>mdi-chevron-right</v-icon>
          <span class="cursor text-subtitle-2"> <span>{{ actionType == 'create' ? 'Create' : 'Update' }}</span> Role</span>
          <v-icon>mdi-chevron-down</v-icon>
        </div>
        <div width="600px"></div>
      </div>

      <UserNavMenu />
    </v-card>
          <v-dialog v-model="successDialog" class="cdz" max-width="366px" max-height="300px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text v-if="CLoading">
              <img src="../assets/admin-loader.gif" width="85px" alt="Loading...">
            </v-card-text>
            <v-card-text class="text-center d-flex flex-column align-center" v-else>
              <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>

              <p class="text-h5 py-4" v-if="actionType == 'create'">NEW ROLE CREATED</p>
              <p class="text-h5 py-4" v-else>Role Updated</p>

              <v-btn class="btn primary-btn" large width="157px" rounded @click="
                successDialog = false;
              $router.push('/roles');
              ">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="usersDialog" class="cdz" max-width="550px" persistent style="overflow: hidden;">
        <v-card>
            <v-card-text v-if="userLoading">
              <img src="../assets/admin-loader.gif" width="85px" alt="Loading...">
            </v-card-text>
            <div class="pa-5" v-else>
              <div class="d-flex justify-space-between align-center mb-5">
               <p class="text-h6">{{ currentHris.name }}</p>
               <v-icon @click="closeUserDialog">mdi-close</v-icon>
              </div>
              <div v-if="users && users.length" class="mx-3">
                 <v-row class="table-head">
                <v-col><span class="head text-subtitle-2">Name</span></v-col>
              </v-row>
              </div>
              <div class="table-items pa-0 ma-0 mt-6">
                <template v-if="users && users.length">
                  <v-row v-for="(user, userIndex) in users" :key="`hris_user_${userIndex}`" :id="`hris_user_${userIndex}`" class="text-body-2">
                    <v-col>
                      <span>{{ user.Full_Name }}</span>
                    </v-col>
                  </v-row>
                </template>
                <div v-else class="text-body-2 pa-4 grey--text text-subtitle-1 text-center">No employees found</div>
              </div>
        
            </div>
          
        </v-card>
      </v-dialog>
 

    <v-container fluid class="createUserPad px-8 pb-0 background" >    
        <v-card outlined class="fixed-bottom-bar pa-4">
          <div class="d-flex justify-end">
            <v-btn class="btn outline-btn" :disabled="!$store.state.role.rolesAndPrivilage.create"
              @click="$router.push('/roles')" rounded>Cancel</v-btn>
            <v-btn class="btn tertiary-btn mx-2" :disabled="(!actionDisable && !isHrisInfoChanged) || !isHrisMappingCompleted"
              @click="createOrUpdateRole" rounded>{{actionType == 'create'? 'Submit': 'Update'}} </v-btn>
          </div>
        </v-card>

      <v-form lazy-validation ref="form" class="formHt" >
        <v-card elevation="0" class="background">
          <v-card elevation="0" outlined class="pa-4 rounded-lg">
            <v-text-field class="rounded-xl" v-model="roles.roleName" label="Role Name (Configured in HubbleSTAR) *" outlined hide-details
              :rules="[(v) => !!v || 'Name is required']" required></v-text-field>
                <v-select label="Role-Based Access *" :items="externalRolesList" outlined class="rounded-xl mt-4 py-0"
                  v-model="roles.externalRoleId" :item-text="item => item.name.replace(/_/g, ' ')" item-value="id" @change="getHirsRolesByRbackId()"
                  :rules="[(v) => !!v || 'RBAC Role selection is required']">
                </v-select>
            <div class="text-body-1 my-2">Role Description</div>
            <v-row>
              <v-col>
                <ckeditor :config="editorConfig" v-model="roles.roleDescription" class="m-ckeditor"
                  @ready="onEditorReady">
                </ckeditor>
              </v-col>
            </v-row>
       
            <v-row>
              <v-col cols="6">
                <v-select label="Landing Page" :items="landingPages" outlined class="rounded-xl py-0"
                  v-model="roles.landingUrl" item-text="page" item-value="url"
                  :rules="[(v) => !!v || 'Landing Page is required']">
                </v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <v-card outlined elevation="0" class="my-4 pb-4 rounded-lg" v-if="externalRoleId">
         <p  class="permission-sticky-container pa-2" > Permissions</p>

         <v-expansion-panels  class="no-gap"  v-model="panel">
          <v-expansion-panel v-for="(group , groupINdex)  in roleGroups" :key="`role_group_${groupINdex}`" @change="handlePanelChange">
    
            <v-expansion-panel-header hide-actions :disabled="!group.isExpandable" ><div class="d-flex justify-space-between align-center">
              <span class="d-flex"> <span class="mr-2">
                <v-img
                v-if="panel == groupINdex && group.isExpandable"
                 src="../assets/svg/accordian-close.svg" 
                 />
                <v-img
                v-if="panel !== groupINdex && group.isExpandable"
                 src="../assets/svg/accordian-open.svg" 
                 />
                <v-img
                v-if="panel !== groupINdex && !group.isExpandable"
                 src="../assets/svg/accordian-disable.svg" 
                 />
                
              </span><span class="text-subtitle-2" >{{ group.title }}</span></span>
              <span class="d-flex" @click.stop>
                <v-checkbox 
                  v-for="permission in Object?.keys(roles.header[group.headerKey])"
                  :key="permission"
                  @click.stop="ensuredReadAndChild(group.headerKey, permission, roles.header[group.headerKey][permission].flag)" 
                  hide-details 
                  class="mw-130 mt-0" 
                  v-model="roles.header[group.headerKey][permission].flag" 
                  :disabled="headerHasAnyCurd(roles.header[group.headerKey], permission) || !group.actionsAllowed.includes(permission)"
                  :label="permission.charAt(0).toUpperCase() + permission.slice(1) + ' (' + roles.header[group.headerKey][permission].selectedCount + '/' + roles.header[group.headerKey][permission].count+')' "
                />  
              </span>
            </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content class="ml-6">
                <div v-if="!group.mappingInfo">
                  <v-expansion-panels  class="no-gap no-border" v-model="subPanel">
                    <v-expansion-panel v-for="(item , itemIndex)  in group.items" :key="item.key">
                      <v-expansion-panel-header hide-actions :disabled="!item?.isExpandable" class="d-flex justify-space-between align-center">
                        <span class="d-flex">
                          <span class="mr-2">
                            <v-img v-if="subPanel == itemIndex && item.isExpandable" src="../assets/svg/accordian-close.svg" />
                            <v-img v-if="subPanel !== itemIndex && item.isExpandable" src="../assets/svg/accordian-open.svg" />
                            <v-img v-if="subPanel !== itemIndex && !item.isExpandable" src="../assets/svg/accordian-disable.svg" />
                          </span>
                          <span>{{item.label}}</span>
                        </span>
                        <span class="d-flex justify-end ma-0 pa-0" @click.stop>
                          <template v-if="item.type === 'single'">
                            <v-checkbox hide-details class="mr-8 mt-0" v-model="roles[item.key]" label="Admin" />
                          </template>
        
                          <!-- For CRUD + Read -->
                          <template v-else>

                            <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].create" label="Create"
                              @change="handleItemChange(item, group, 'create')" :disabled="!group.actionsAllowed.includes('create')"/>
                            <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].read" label="Read" :disabled="hasAnyCrud(roles[item.key]) || !group.actionsAllowed.includes('read')"
                              @change="handleItemChange(item, group, 'read')"/>
                            <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].update" label="Update"
                              @change="handleItemChange(item, group, 'update')" :disabled="!group.actionsAllowed.includes('update')" />
                            <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].delete" label="Delete"
                              @change="handleItemChange(item, group, 'delete')" :disabled="!group.actionsAllowed.includes('delete')" />
                          </template>
                        </span>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <template>
                          <v-row v-for="subItem in item?.subItems" class="ml-6" :key="subItem.key">
                            <v-col cols="4" sm="4" md="4" class="ma-0 pa-0 pt-5">
                              <v-card-text class="ma-0 pa-0 text-body-2 ">{{ subItem.label }}</v-card-text>
                            </v-col>
                  
                            <v-col cols="8" sm="8" class="d-flex flex-row justify-end ma-0 pa-0">
                              <!-- For single permission -->
                              <template v-if="subItem.type === 'single'">
                                <v-checkbox hide-details class="mr-8 mt-0" v-model="roles[subItem.key]" label="Admin" />
                              </template>
            
                               <!-- For CRUD + Read -->
                              <template v-else>
                                <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[subItem.key].create" label="Create"
                                  @change="handleSubItemChange(item, group, 'create')" :disabled="!item.actionsAllowed.includes('create')"/>
                                  <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[subItem.key].read" label="Read" 
                                  @change="handleSubItemChange(item, group, 'read')" :disabled="hasAnyCrud(roles[subItem.key]) || !item.actionsAllowed.includes('read')" />
                                <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[subItem.key].update" label="Update"
                                  @change="handleSubItemChange(item, group, 'update')" :disabled="!item.actionsAllowed.includes('update')" />
                                <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[subItem.key].delete" label="Delete"
                                  @change="handleSubItemChange(item, group, 'delete')" :disabled="!item.actionsAllowed.includes('delete')" />
                              </template>
                            </v-col>
                          </v-row>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <div v-if="group.mappingInfoFlag" class="d-flex flex-column gap-24 px-12 py-3">
                  <div v-for="(hris, index) in hrisRoles" :key="index">
                      <v-card rounded :key="index" class="pa-2 mx-auto">
                      <div class="d-flex justify-space-between align-center pa-2">
                        <p class="text-h6">{{hris.name}}</p>
                      <v-btn class="btn outline-btn" 
                      @click="viewUser(hris)" rounded>View users</v-btn>
                      </div>
                      <v-row class="px-2">
                        <v-col v-for="(info, infoIndex) in hris.additionalInfo[group.headerKey]" cols="6" :key="infoIndex">
                           <v-autocomplete clearable :label="`${info.fieldName}*`" outlined v-model="info.value"
                              required :rules="[(v) => !!v || 'Levels are required']" class="rounded-xl" :items="getItemsForField(info.fieldType)"
                              multiple item-text="name" item-value="name" flat 
                              @change="getGradesMappedToLevels"
                              :hint="info.helpText"
                              persistent-hint>
                              <template #selection="{ item }">
                                <v-chip @click:close="deleteChip(item.value, info.value)" close-icon="mdi-close" text-color="white" close>
                                  {{ item.name }}
                                </v-chip>
                              </template>
                              <v-list-item slot="prepend-item" ripple @click="selectAll(getItemsForField(info.fieldType), info)" @change="onHrisMappingUpdate">
                                <v-list-item-action>
                                  <v-checkbox :value="info.value.length === getItemsForField(info.fieldType).length && getItemsForField(info.fieldType).length > 0">
                                  </v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-card>
                    <div v-if="index == 0 && false" @click="applyFirstItemValues(group)"> 
                      <!-- commented temprorialy -->
                        <span class="d-flex align-center text-h6 copy-inactive pointer">  <v-checkbox  v-model="group.hasCopyAbove"
                                    >
                                  </v-checkbox>  <span class="copy-inactive cursor"> Copy the above</span></span>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
              
          </v-expansion-panel>
         </v-expansion-panels>
       
      </v-card>
      </v-form>
   
    </v-container>
    <v-dialog v-model="notificationDialog" class="cdz" max-width="380px">
      <Notification @close-dialog="notificationDialog = false" />
    </v-dialog>
  </div>
</template>
<script>
import ClusterController from "@/controllers/ClusterController";
import SchoolController from "@/controllers/SchoolController";
import RolesController from "@/controllers/RolesController";
import AuthService from "../services/AuthService";
import Notification from "./Notification";
import UsersController from "@/controllers/UsersController";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
  name: "CreateRoleView",
  components: {
    Notification,UserNavMenu
  },
  data() {
    return {
      actionType: '',
      permissionString: '',
      createdString: '',
      updatedString:'',
      externalRoleId: '',
      updationPermissionString: '',
      isanyRoleChecked: false,
      observedUsers: new Set(),
      currentPage:1,
      userScrollObserver:null,
      panel:0,
      subPanel: 0,
      usersDialog:false,
      userLoading: false,
      notificationDialog: false,
      currentHris: {},
      orgTypes: [],
      users: [],
      clusterData: [
        {
          name: "All Clusters",
          id: "all",
        },
      ],
      schools: [
        { name: "All" }
      ],
      hrisRoles:[],
      update: false,
      roleId: "",
      CLoading: false,
      successDialog: false,
      adminKeys: [
        "cluster",
        "Brand",
        "board",
        "school",
        "Level",
        "Grade",
        "subjectCategory",
        "subjects",
        "skills",
        "learningObjective",
        "league",
        "topics",
        "interview"
      ],
      userKeys: [
        "teacherOnboarding",
      ],
      initialRoleState: null,
      roles: {
        roleName: "",
        externalRoleId: "",
        roleDescription: "",
        landingUrl:"/",
        clusterName: "",
        users: [],
        schools: [],
        header:{ 
          interviewHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          restartHead:  {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          candidateListingHead:  {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          questionBankHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          assessmentHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          campaignHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          dashboardHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          mastersHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   },
          usersHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },   }, 
          rolesHead: {create: {
            flag: false,
            count:0,
            selectedCount:0
          },read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          }, delete: {
            flag: false,
            count:0,
            selectedCount:0
          },},
          jobseekerHead: {
            create: {
              flag: false,
              count:0,
              selectedCount:0
            },
          read: {
            flag: false,
            count:0,
            selectedCount:0
          },
           update: {
            flag: false,
            count:0,
            selectedCount:0
          },
          delete: {
            flag: false,
            count:0,
            selectedCount:0
          },}
        },
        jobseeker: { create: false, update: false, delete: false, read: false },
        slotApprover:{ create: false, update: false, delete: false, read: false },
        vgos: { create: false, update: false, delete: false, read: false },
        mesta: { create: false, update: false, delete: false, read: false },
        userManagement: { create: false, update: false, delete: false, read: false },
        teacherOnboarding: { create: false, update: false, delete: false, read: false },
        rolesAndPrivilage: { create: false, update: false, delete: false, read: false },
        masters: { create: false, update: false, delete: false, read: false },
        cluster: { create: false, update: false, delete: false, read: false },
        Brand: { create: false, update: false, delete: false, read: false },
        school: { create: false, update: false, delete: false, read: false },
        board: { create: false, update: false, delete: false, read: false },
        Level: { create: false, update: false, delete: false, read: false },
        Grade: { create: false, update: false, delete: false, read: false },
        subjectCategory: { create: false, update: false, delete: false, read: false },
        subjects: { create: false, update: false, delete: false, read: false },
        skills: { create: false, update: false, delete: false, read: false },
        learningObjective: { create: false, update: false, delete: false, read: false },
        league: { create: false, update: false, delete: false, read: false }, 
        campaign: { create: false, update: false, delete: false, read: false },
        assessment: { create: false, update: false, delete: false, read: false },
        questionBank: { create: false, update: false, delete: false, read: false },
        topics: { create: false, update: false, delete: false, read: false },
        interview: { create: false, update: false, delete: false, read: false },
        intervieweeList: { create: false, update: false, delete: false, read: false },
        candidatesListing: { create: false, update: false, delete: false, read: false },
        canRestartAssessment: { create: false, update: false, delete: false, read: false },
        skillWeightageThreshold: { create: false, update: false, delete: false, read: false },
        hirsUniqeRole:  { create: false, update: false, delete: false, read: false },
        managementDashboard: { create: false, update: false, delete: false, read: false },
        trendlineDashboard: { create: false, update: false, delete: false, read: false },
        comparisonDashboard: { create: false, update: false, delete: false, read: false },
        mixpanelDashboard: { create: false, update: false, delete: false, read: false },
      },
      initialHrisInfo: null,
      campaignTypes: [],
      externalRolesList: [],
      roleGroups: [
           {
          title: 'Dashboard',
           isExpandable: true,
           mappingInfoFlag:false,
           hasCopyAbove:false,
           headerKey: 'dashboardHead',
           actionsAllowed: ['read'],
            items: [
              { 
                key: 'jobseeker',
                label: 'Job Seeker',
                isExpandable: true,
                headerKey: 'jobseekerHead',
                actionsAllowed: ['read'],
                subItems:[
                  { key: 'managementDashboard', label: 'Overview Dashboard', headerKey: 'jobseekerHead'},
                  { key:'trendlineDashboard',  label: 'Trending Dashboard', headerKey: 'jobseekerHead'},
                  { key:'comparisonDashboard',  label: 'Comparison Dashboard', headerKey: 'jobseekerHead'},
                  { key:'mixpanelDashboard',  label: 'Mix Panel Dashboard', headerKey: 'jobseekerHead'},
                ] 
              },
              { key: 'vgos', label: 'VGOS', actionsAllowed: ['read'],},
              { key: 'mesta', label: 'MESTA', actionsAllowed: ['read'], },
            ]
        },
        {
          title: 'User Management',
          headerKey: 'usersHead',
          isExpandable: false,
          hasCopyAbove:false,
          mappingInfoFlag:false,
          actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'teacherOnboarding', label: 'Onboarding' },
          ]
        },
               {
          title: 'Campaign',
          mappingInfoFlag:true,
          hasCopyAbove:false,
          actionsAllowed: ['create','read', 'update', 'delete'],
          mappingInfo: [
            {fieldType: 'campaingType', fieldName:'Campaign Type', helpText:'', value: []}, 
            {fieldType: 'orgType', fieldName:'Organisation', helpText:'Select the organization to which you want to provide access', value: []}
        ],

          headerKey: 'campaignHead',
          isExpandable: false,
          items: [
             { key: 'campaign', label: 'Campaign' },
          ]
        },
             {
          title: 'Assessment',
          headerKey: 'assessmentHead',
          isExpandable: false,
          mappingInfoFlag:false,
          hasCopyAbove:false,
          actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'assessment', label: 'Assessment' },
          ]
        },
        
         {
          title: 'Question Bank',
          headerKey: 'questionBankHead',
           mappingInfoFlag:false,
          isExpandable: false,
          hasCopyAbove:false,
          actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'questionBank', label: 'Question Bank' },
           ]
        },
        {
          title: 'Candidate Listing For Hiring Manager',
          headerKey: 'candidateListingHead',
           mappingInfoFlag:false,
           isExpandable: false,
           hasCopyAbove:false,
           actionsAllowed: ['read', 'update'],
          items: [
            { key: 'candidatesListing', label: 'Candidate Listing For Hiring Manager' },
          ]
        },
          {
          title: 'Roles',
          headerKey: 'rolesHead',
           mappingInfoFlag:false,
           isExpandable: false,
           hasCopyAbove:false,
           actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'rolesAndPrivilage', label: 'Roles' },
          ]
        },
        {
          title: 'Masters',
          headerKey: 'mastersHead',
          isExpandable: true,
          hasCopyAbove:false,
          mappingInfoFlag:false,
          actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'cluster', label: 'Cluster'},
            { key: 'Brand', label: 'Brand' },
            { key: 'school', label: 'School' },
            { key: 'board', label: 'Board' },
            { key: 'Level', label: 'Level' },
            { key: 'Grade', label: 'Grade' },
            { key: 'subjectCategory', label: 'Subject Category' },
            { key: 'subjects', label: 'Subjects' },
            { key: 'skills', label: 'Skills' },
            { key: 'learningObjective', label: 'Learning Objective' },
            { key: 'league', label: 'League' },
            { key: 'topics', label: 'Topics' },
            { key: 'hirsUniqeRole', label: 'HRIS Unique Role' },
            {key: 'skillWeightageThreshold', label: 'Skills- Weightage and Thresholds'},
         
          ]
        },
        {
          title: 'Restart Assessment',
          headerKey: 'restartHead',
           isExpandable: false,
            mappingInfoFlag:false,
            hasCopyAbove:false,
            actionsAllowed: ['read'],
          items: [
            { key: 'canRestartAssessment', label: 'Restart Assessment', type: 'single' }
          ]
        },
           {
          title: 'Interview',
          headerKey: 'interviewHead',
           mappingInfoFlag:false,
           isExpandable: true,
           hasCopyAbove:false,
           actionsAllowed: ['create','read', 'update', 'delete'],
          items: [
            { key: 'interview', label: 'Interview' },
            { key: 'intervieweeList', label: 'Interviewee List' },
            {key: 'slotApprover', label: 'Slot Approver'}
          ]
        },

     
      ],
      editorConfig: {
        extraPlugins: "ckeditor_wiris",
      },
      editorConfigForOption: {
        extraPlugins: "ckeditor_wiris",
      },
      landingPages:[
      {
          page:"Dashboard",
          url:"/"
        },
        {
          page:"Candidate Listing",
          url:"/candidate-list"
        },
        {
          page:"Question Bank",
          url:"/question-bank"
        }
      ],
      existingRoleData: {}
    };
  },

  methods: {
    conditionalExpansionOfRoleItem(){
      if(this.hasCampainChecked){
        this.roleGroups.find(item => item.headerKey == 'campaignHead').isExpandable = true
      }
    },
    stringCreationPattern(string){
       const {roleName,  externalRoleId} = this.roles
       return this.removeSpecialChars(roleName+externalRoleId+string)
    },
    removeSpecialChars(str) {
      return str.replace(/[^a-zA-Z0-9]/g, '');
    },
    calculateHeaderCount(){
        let crud = ['create', 'read', 'update', 'delete']

       this.roleGroups.forEach((rg)=>{
         const totals = { create: 0, update: 0, read: 0, delete: 0 };
        let groupItems = rg.items;
        let groupHeader = rg.headerKey

              groupItems.forEach((gi)=> {
                crud.forEach((action)=>{
                  totals[action] += this.roles[gi.key][action] ? 1:  0
              })
              
              crud.forEach((action)=>{
                this.roles.header[groupHeader][action].selectedCount = totals[action]
                this.roles.header[groupHeader][action].flag = totals[action] > 0
              })

          })
        })
         
    },
    isObjectEqual(obj1, obj2) {
      // If both are null or undefined and equal
      if (obj1 === obj2) return true;
      
      // If one is null/undefined and the other isn't
      if (obj1 == null || obj2 == null) return false;
      
      // Compare array contents (order matters)
      if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return false;
        
        for (let i = 0; i < obj1.length; i++) {
          if (!this.isObjectEqual(obj1[i], obj2[i])) return false;
        }
        return true;
      }
      
      // Compare objects
      if (typeof obj1 === 'object' && typeof obj2 === 'object') {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        
        if (keys1.length !== keys2.length) return false;
        
        for (const key of keys1) {
          if (!keys2.includes(key)) return false;
          if (!this.isObjectEqual(obj1[key], obj2[key])) return false;
        }
        return true;
      }
      
      // Compare primitive values
      return obj1 === obj2;
    },
    async getOrganisationTypes(){
      const response = await UsersController.getOrganisationTypes()
      if(response.status == 200){
          this.orgTypes = response.data.organisationTypes.map((item) => ({
          'value': item.name, 
          ...item
        }))
      }
    },
    async getRoleById(){
       let query = '?id='+this.roleId
       const response = await RolesController.getRoleById(query)
       if(response.status == 200 && response.data.flag){
        this.existingRoleData = response.data.data[0]
       }
    },
    async getCampaignTypes(){
         const response = await UsersController.getCampaignTypes()

      if(response.status == 200){
        this.campaignTypes = response.data.campaignTypes.map((item) => ({
          'value': item.name, 
          ...item
        }))
      }
    },
    async getHirsRolesByRbackId(){
      this.externalRoleId = `${this.roles.externalRoleId}`
      let query = '?rbacId='+this.roles.externalRoleId
      const response = await UsersController.getHrisRolesFromRbacById(query)
      let mappingInfoFields = this.roleGroups.filter(({mappingInfoFlag})=>mappingInfoFlag)

      if(response.data.status){
        this.hrisRoles = response.data.data.map((item)=>{
          let element = {...item}
          element['name'] = item.HRIS_Unique_Role
        
          if(mappingInfoFields.length > 0 ){
            element.additionalInfo = {}
            mappingInfoFields.forEach((mapping)=>{
              // Create a deep copy of mappingInfo for each HRIS role
              element.additionalInfo[`${mapping.headerKey}`] = mapping.mappingInfo.map(info => ({
                ...info,
                value: [...(info.value || [])] // Ensure value is also a new array
              }))
            })
          }
          return element 
        })
      }else {
        this.hrisRoles = []
      }
    },
       permissionsToString() {
      const roleKeys = [
        'jobseeker', 'vgos', 'mesta', , 'teacherOnboarding', 'hirsUniqeRole',
        , 'rolesAndPrivilage', 'masters', 'cluster', 'Brand',
        'school', 'board', 'Level', 'Grade', 'subjectCategory', 'subjects', 'skills',
        'learningObjective', 'league', 'campaign', 'assessment', 'questionBank',
        'topics', 'interview', 'candidatesListing', 'canRestartAssessment', 'skillWeightageThreshold',
        'managementDashboard','trendlineDashboard', 'comparisonDashboard', 'mixpanelDashboard'
      ]; 
      let permissionsObj = {};
      roleKeys.forEach(key => {
        if (typeof this.roles[key] === 'boolean') {
          permissionsObj[key] = this.roles[key] ? {read: true} : {read: false};
        } else {
          permissionsObj[key] = this.roles[key];
        }
      });

      return Object.entries(permissionsObj)
        .flatMap(([module, perms]) => 
          Object.entries(perms)
            .filter(([_, value]) => value)
            .map(([action, _]) => `${module}.${action}`)
        )
        .sort()
        .join('|');
    },  
    closeUserDialog(){
      this.usersDialog = false;
      this.resetUsers()

    },
    resetUsers(){
      this.currentPage = 1;
      this.users = []
      this.observedUsers = new Set()
    },
     initIntersectionObserver() {
      // Create the observer
      this.userScrollObserver = new IntersectionObserver(async(entries) => {
        let entry = entries[0]
          if (entry.isIntersecting) {
           const elementId = entry.target.id;
             if(this.observedUsers.has(elementId)){
              return;  
            }
              this.observedUsers.add(elementId);         

            this.currentPage++
             await  this.getHrisUsers()
          }
        
      }, {
        root: document.querySelector('.table-items'), // The dropdown content
        threshold: 0  
      });
    },
    applyFirstItemValues(src){

      src.hasCopyAbove = !src.hasCopyAbove

    // take the first value and apply to all below items 
    let fistItemVal
    let secondItemVal

    // get the first items vals 
    // apply to all 
    },
    getGradesMappedToLevels(){
    },
   async viewUser(hris){
       this.currentHris = hris
     await this.getHrisUsers()
      this.usersDialog = true
    
    },
    deleteChip(deletedValue, array){
      let index = array.indexOf(deletedValue);
      array.splice(index, 1)

    },
    selectAll(allItems, infoObject) {   
      const allValues = allItems.map(item => item.value)
      
      // Check if all items are already selected
      if (infoObject.value.length === allItems.length) {
        // Deselect all
        infoObject.value = []
      } else {
        // Select all
        infoObject.value = [...allValues]
      }
    },
    onHrisMappingUpdate(){
    },
    populateHeaderItemCount(){
      let crudItems = ['create','read','update','delete']
      Object.keys(this.roles.header).forEach((head)=>{
       let headerItemCounts =  this.roleGroups.find(({headerKey})=>headerKey == head)?.items?.length || 0;
        crudItems.forEach((el)=>{
          this.roles.header[head][el].count = headerItemCounts
       })
        
      })

    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function(event) {
        var commandName = event.data.name;
        if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
          setTimeout(() => {
              const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
              wiris_license_overlays.forEach(element => {
                element.remove();
              });
            }, 2000)
        }
      })
    },
       getItemsForField(fieldType) {
        if (fieldType === 'campaingType') {
            return this.campaignTypes;
        } else if (fieldType === 'orgType') {
            return this.orgTypes; 
        }
        return [];
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    createOrUpdateRole() {
      if (this.actionType == 'update') {
        this.updateRole();
      } else {
        this.createRole();
      }
    },
    moveToRole() {
      this.$router.push("/roles");
    },
    async createRole() {
      if (this.$refs.form.validate()) {
        this.CLoading = true;
        this.adminKeys.forEach((obj) => {
          if (this.roles[obj].admin == true || this.roles[obj].read == true) {
            this.roles.masters.read = true;
            this.roles.masters.admin = true;
          }
        });
        this.userKeys.forEach((data) => {
          if (this.roles[data].admin == true || this.roles[data].read == true) {
            this.roles.userManagement.read = true;
            this.roles.userManagement.admin = true;
          }
        });
        this.roles['hris_info'] = this.hrisRoles || []
        this.roles['uique_identifier'] = this.stringCreationPattern(this.permissionString)
        const response = await RolesController.createRole(this.roles);
        if (response.data.flag) {
          this.CLoading = false;
          this.successDialog = true;
        } else {
          alert("Failed");
        }
      }
    },
    handleMasterPermission(){
      let masterHead = this.roles.header.mastersHead
      let readCount = 0;
      let adminCount = 0;
      if(this.roles.masters){
        readCount =  masterHead.read.selectedCount; 
         Object.keys(masterHead).forEach((key)=>{
          if(key !== 'read'){
            adminCount += masterHead[key].selectedCount
          }
         })
        
         this.roles.masters = {admin: adminCount > 0, 
          read: readCount > 0 
         }
      }

    },
    async getSchool() {

      if (this.roles.clusterName != 'All Clusters') {
        var temp = [this.roles.clusterName]
        this.schools = [];
        const response = await SchoolController.getClusterSchool(temp);
        if (response.data.flag) {
          var schools = response.data.schools;
          this.schools = ['All', ...schools];

        } else {
          alert(response.data.error);
        }
      }
      else {
        this.roles.schools = "All"
      }
    },
    observeLastTenthItem() {
      let attempts = 0;
      let maxAttempts = 10;
        const delayPromise = async () => new Promise((res, rej)=>{
          setTimeout(()=>{
            res()
        },500*attempts)
        })
    
      // Get all list items in the dropdown
      const observeCb = async () => {
        const lastTenthEl = document.getElementById(`hris_user_${this.users.length - 10}`);
        // Observe the last item
        if (lastTenthEl) {
          this.userScrollObserver?.disconnect();
          this.userScrollObserver.observe(lastTenthEl);
        }else if (attempts <= maxAttempts){
          attempts++
          await delayPromise()
          observeCb()

        }
      }
       
       observeCb()       
    },
    async getHrisUsers(){
      let query = '?HRIS_Unique_Role_Code=' + this.currentHris.HRIS_Long_Role_Code +  '&page='+this.currentPage+'&limit='+20;
      const response = await UsersController.getHrisUsers(query)
     this.users.push(...response.data.data)
      await this.$nextTick()
      let hasmore = response.data.pagination.hasNextPage
      if(hasmore){
         this.observeLastTenthItem()
      }
     

    },
    async getExternalRolesList() {
      const response = await UsersController.fetchRBACRoles();
      if (response.flag) {
        this.externalRolesList = response.roles;
      } else {
        alert(response.error);
      }
    },
    handlePanelChange(){
      this.subPanel = null;
    },
    handleItemChange(item, group, action) {
      const value = this.roles[item.key][action]

      // If item has subItems → sync them
      if (item.subItems?.length) {
        item.subItems.forEach(sub => {
          this.roles[sub.key][action] = value

          // If enabling CRUD → force read
          if (action !== 'read' && value) {
            this.roles[sub.key].read = true
          }
        })
      }

      // If enabling CRUD on parent → force read
      if (action !== 'read' && value) {
        this.roles[item.key].read = true
      }

      // Update header
      this.updateHeaderCount(group.items, action, group.headerKey)

      this.permissionString = this.permissionsToString()
    },
    ensuredReadAndChild(destination, key, model){ 
      this.updtateHeaderSelectionCount(destination, key, model)
      this.childCheckBoxUpdate(destination, key, model)
      this.permissionString = this.permissionsToString();
      this.conditionalExpansionOfRoleItem()
    
    },
    updtateHeaderSelectionCount(destination, key, model){ 
      if(model){
        if(key == 'read'){
            this.roles.header[destination][key]['selectedCount'] = this.roleGroups.find((i)=> i.headerKey == destination).items.length; 
            this.roles.header[destination][key]['flag'] = true 
        }else{
          this.roles.header[destination][key]['selectedCount'] = this.roleGroups.find((i)=> i.headerKey == destination).items.length;
           this.roles.header[destination]['read']['selectedCount'] = this.roleGroups.find((i)=> i.headerKey == destination).items.length;
            this.roles.header[destination][key]['flag'] = true 
            this.roles.header[destination]['read']['flag'] = true 
        }

      }else{
        this.roles.header[destination][key]['selectedCount'] = 0
      }
    },  
    childCheckBoxUpdate(destination, key, model){
         let itemsToupdate = this.getAllChilds(destination);
         itemsToupdate.forEach((item)=>{
          this.roles[item][key] = model
          if(key !== 'read' && model){
            this.roles[item].read = model
          }
      })
    },
    updateMyHeader(groupItems, action, headerKey){
      this.updateHeaderCount(groupItems, action, headerKey)
      this.conditionalExpansionOfRoleItem()
    
    },
    updateHeaderCount(groupItems, action, headerKey) {
      const total = groupItems.length;

      const selected = groupItems.map(item => this.roles[item.key][action]).filter(Boolean).length;

      this.roles.header[headerKey][action].selectedCount = selected;
      this.roles.header[headerKey][action].flag = selected > 0;

      // Update read separately if CRUD selected
      if (action !== 'read') {
        const readCount = groupItems.map(item => this.roles[item.key].read).filter(Boolean).length;

        this.roles.header[headerKey].read.selectedCount = readCount;
        this.roles.header[headerKey].read.flag = (readCount > 0);
      }

      this.permissionString = this.permissionsToString();
    },
    getAllChilds(destination) {
      const group = this.roleGroups.find(item => item.headerKey === destination);

      if (!group) return []

      const allItems = group.items.flatMap(item => item.subItems?.length ? [item, ...item.subItems] : item );

      return allItems.map(i => i.key);
    },
    handleSubItemChange(item, group, action) {
      if (!item.subItems) return

      // Update parent item role
      this.roles[item.key][action] = action

      // Now update header
      this.updateHeaderCount(group.items, action, group.headerKey)
    },
    headerHasAnyCurd(data, permission){
       if(permission == 'read'){
        return  data.create.flag || data.update.flag || data.delete.flag;
       }     
      return false

    },
    hasAnyCrud(role) {
      return role.create || role.update || role.delete;
    },
    hasFormChanged() {
      if (!this.initialRoleState) return false;
      
      // Check if basic info changed
      if (this.roles.roleName !== this.initialRoleState.roleName ||
          this.roles.externalRoleId !== this.initialRoleState.externalRoleId ||
          this.roles.roleDescription !== this.initialRoleState.roleDescription ||
          this.roles.landingUrl !== this.initialRoleState.landingUrl) {
        return true;
      }
      
      // Check if permissions changed
      const currentPermissionString = this.permissionsToString();
      return currentPermissionString !== this.initialRoleState.permissionString;
    },
     async updateRole() {
      this.CLoading = true;
      this.roles['hris_info'] = this.hrisRoles || []
      this.roles['uique_identifier'] = this.stringCreationPattern(this.permissionString)
      this.handleMasterPermission()
      const response = await RolesController.updateRole(this.roles, this.roles.id);
      if (response.data.flag) {
        this.CLoading = false;
        this.successDialog = true;
        this.$store.state.updateRole = null
      } else {
        alert("Failed");
      }
    },
    getExistingHris(){
        this.hrisRoles = this.roles.hris_info
        if(this.roles.hris_info){
           this.initialHrisInfo = JSON.parse(JSON.stringify(this.roles.hris_info));
        }else if(this.roles.externalRoleId){
          this.getHirsRolesByRbackId()
        }
       
    }, 
      deepMerge(target, source) {
        Object.keys(source).forEach(key => {
          if (
            source[key] &&
            typeof source[key] === "object" &&
            !Array.isArray(source[key])
          ) {
            if (!target[key]) {
              target[key] = {};
            }
            this.deepMerge(target[key], source[key]);
          } else {
            target[key] = source[key];
          }
        });
        return target;
      },
    // Modified updatePrecursor to store initial state
    async updatePrecursor() {
    
      if (this.roleId !== '' || this.roleId !== null) {
        await this.getRoleById()  
        this.roles = this.deepMerge({ ...this.roles }, this.existingRoleData); 
        if(typeof this.roles['canRestartAssessment'] == 'boolean'){
          if(this.roles['canRestartAssessment']){
             this.roles['canRestartAssessment'] = { create: true, update: true, delete: true, read: true }
          }else {
              this.roles['canRestartAssessment'] = { create: false, update: false, delete: false, read: false }
          }
         
        }
        let roleDescription = this.roles.roleDescription;
        this.externalRoleId = `${this.roles.externalRoleId}`;
        
        // Store initial state for comparison
        this.initialRoleState = {
          roleName: this.roles.roleName,
          externalRoleId: this.roles.externalRoleId,
          roleDescription: this.roles.roleDescription,
          landingUrl: this.roles.landingUrl,
          permissionString: this.permissionsToString(),
          hris_info: JSON.parse(JSON.stringify(this.roles.hris_info || []))
        };
        
        this.createdString = this.roles['uique_identifier'];
        this.permissionString = this.roles['uique_identifier'];
        this.calculateHeaderCount();
        this.getExistingHris();
        this.conditionalExpansionOfRoleItem()
        setTimeout(() => {
          this.roles.roleDescription = roleDescription;
        }, 1000);

      } else {
      }
    },
  disableSubmitOrUpdate() {
      const { roleName, externalRoleId } = this.roles;
      
      // Basic validation
      if (!roleName || !externalRoleId) {
        return false;
      }
      
      if (this.actionType === 'create') {
        return this.$store.state.role.rolesAndPrivilage.create && 
               this.permissionString?.length > 0;
      } else {
        // For update, check if anything has changed
        return this.hasFormChanged();
      }
    },
        hasFormChanged() {
      if (!this.initialRoleState) return false;
      
      // Check if basic info changed
      if (this.roles.roleName !== this.initialRoleState.roleName ||
          this.roles.externalRoleId !== this.initialRoleState.externalRoleId ||
          this.roles.roleDescription !== this.initialRoleState.roleDescription ||
          this.roles.landingUrl !== this.initialRoleState.landingUrl) {
        return true;
      }
      
      // Check if permissions changed
      const currentPermissionString = this.permissionsToString();
      return currentPermissionString !== this.initialRoleState.permissionString;
    },
  },
  computed:{
    hasCampainChecked(){
    const campaign = this.roles.campaign
    return campaign.read || campaign.create || campaign.update || campaign.delete
    },
    isHrisMappingCompleted(){
       if(this.hasCampainChecked){
        return  this.hrisRoles?.every((role)=> role?.additionalInfo?.campaignHead.every((info)=> info?.value?.length > 0 ))
      }else {
        return true 
      }

    },  
      isHrisInfoChanged() {
      if (!this.initialHrisInfo && !this.roles.hris_info) return false;
      if (!this.initialHrisInfo || !this.roles.hris_info) return true;
      
      return !this.isObjectEqual(this.initialHrisInfo, this.roles.hris_info);
    },
    actionDisable() {
      return this.disableSubmitOrUpdate();
    }
  },
  async mounted() {
    if(this.$route.query.actionType){
      this.actionType =  this.$route.query.actionType;
    }
    if(this.$route.query.roleId){
      this.roleId = this.$route.query.roleId
    }
    if(this.actionType == 'update'){
      this.updatePrecursor()
    }
   await  this.getOrganisationTypes()
    await this.getCampaignTypes()
    this.populateHeaderItemCount()
    // add event listener for beforeunload event
    if (!this.$store.state.role.rolesAndPrivilage.read) {
      this.$router.push("/notFound");
    }
  await  this.getExternalRolesList()
  },
  created() {
    this.initIntersectionObserver()
  },
}
</script>
<style scoped>
.gap-24{
  gap:24px;
}
.copy-inactive{
  color: var(--gray)
  
}
.table-items{
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.table-items::-webkit-scrollbar {
  display: none;
}

.table-items {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}

.table-head{
  background-color: #EBF2FF;
  color: var(--blue-01);
   border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.formHt{
  height: calc(100vh - 120px) !important;
  overflow: auto;
}
.formHt::-webkit-scrollbar {
  display: none;
}
.fixed-bottom-bar{
  position: fixed;
  bottom:0;
  z-index: 201;
  width:calc(100vw - 165px)
}
.permission-sticky-container{
  position:sticky;
  top:0px;
  color: var(--blue-01);
  background: var(--gray-02);
  z-index:200;
}

.no-gap .v-expansion-panel {
  margin: 0px !important;
}
.v-application .v-expansion-panel-header--active {
    border-bottom: 1px solid #E0E0E0 !important;
    border-top: 1px solid #E0E0E0 !important;
}
.no-gap .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
.v-expansion-panel-header{
  padding: 5px 12px;
}
.mw-130{
  min-width: 125px;
}
.v-dialog, .v-dialog--active{
  overflow: hidden !important;
}

/* Custom chip styling */
.v-application .v-chip {
  background-color: #CFD5F1 !important; /* Light blue background */
  color: #3F41D1 !important; /* Blue text color */
  /* border: 1px solid  #3F41D1 !important; */
}
.theme--light.v-icon {
    color: #3F41D1
}

/* Chip text color */
.v-application .v-chip .v-chip__content {
  color: #3F41D1 !important; /* Blue text */
}

/* Close icon (X) styling */
.v-chip .v-icon {
  color: #3F41D1 !important; /* Blue close icon */
}

/* Hover effects */
.v-chip:hover {
  background-color: #E0E0E0 !important; /* Darker blue on hover */
  color: #666666 !important;
  border: 1px solid #666666 !important;
}

.v-chip .v-icon:hover {
  color: #0d47a1 !important; /* Darker blue for close icon on hover */
}
.no-border .v-expansion-panel {
  border: none !important;
}

.no-border .v-expansion-panel::before {
  display: none !important;
}

.no-border .v-expansion-panel-header {
  border-bottom: none !important;
}

.no-border .v-expansion-panel::before,
.no-border .v-expansion-panel::after {
  display: none !important;
  border: none !important;
}

.no-border .v-expansion-panel-header::before,
.no-border .v-expansion-panel-header::after {
  display: none !important;
  border: none !important;
}

.no-border .v-expansion-panel {
  border: none !important;
  box-shadow: none !important;
}

</style>